"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _index = require("../index");

var _immutable = require("immutable");

var _reduxPersist = require("redux-persist");

var _actions = require("../actions");

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var initialState = {
  acceptedConditions: false,
  favorites: (0, _immutable.Map)(),
  recent: (0, _immutable.Map)(),
  ratings: (0, _immutable.Map)(),
  scrollTop: null,
  scrollUrl: null,
  promoSkipped: false,
  media: null,
  networkOnline: null
};
var rehydrateState = {
  scrollTop: null,
  scrollUrl: null,
  acceptedConditions: false,
  promoSkipped: false,
  media: null,
  networkOnline: null,
  searchOpened: false
};

function user() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : initialState;
  var action = arguments.length > 1 ? arguments[1] : undefined;
  var payload = action.payload;

  var _getConfig = (0, _index.getConfig)(),
      MAX_RECENTLY_VIEWED_QUEUE = _getConfig.MAX_RECENTLY_VIEWED_QUEUE,
      MAX_FAVORITES_QUEUE = _getConfig.MAX_FAVORITES_QUEUE,
      MAX_RATINGS_QUEUE = _getConfig.MAX_RATINGS_QUEUE;

  var map;
  var topicPath;

  switch (action.type) {
    case _actions.ACCEPT_CONDITIONS:
      return _objectSpread(_objectSpread({}, state), {}, {
        acceptedConditions: true
      });

    case _actions.ADD_RECENT:
      map = state.recent;
      topicPath = [payload.brand, payload.year, payload.model, payload.productType, payload.productSubtype].filter(function (path) {
        return path;
      });
      if (!map.hasIn(topicPath)) map = map.setIn(topicPath, (0, _immutable.List)());
      map = map.updateIn(topicPath, function (list) {
        list = list // if topic is already in recent, remove it and add it again to preserve topic navigation order
        .filterNot(function (topic) {
          return topic === payload.topic;
        });
        if (MAX_RECENTLY_VIEWED_QUEUE && list.size >= MAX_RECENTLY_VIEWED_QUEUE) list = list.pop();
        return list.unshift(payload.topic);
      });
      return _objectSpread(_objectSpread({}, state), {}, {
        recent: map
      });

    case _actions.ADD_FAVORITE:
      map = state.favorites;
      topicPath = [payload.brand, payload.year, payload.model, payload.productType, payload.productSubtype].filter(function (path) {
        return path;
      });
      if (!map.hasIn(topicPath)) map = map.setIn(topicPath, (0, _immutable.List)());
      map = map.updateIn(topicPath, function (list) {
        list = list // if topic is already in favorites, remove it and add it again to preserve topic navigation order
        .filterNot(function (topic) {
          return topic === payload.topic;
        });
        if (MAX_FAVORITES_QUEUE && list.size >= MAX_FAVORITES_QUEUE) list = list.shift();
        return list.push(payload.topic);
      });
      return _objectSpread(_objectSpread({}, state), {}, {
        favorites: map
      });

    case _actions.REMOVE_FAVORITE:
      map = state.favorites;
      topicPath = [payload.brand, payload.year, payload.model, payload.productType, payload.productSubtype].filter(function (path) {
        return path;
      });
      map = map.updateIn(topicPath, function (list) {
        return list.filterNot(function (topic) {
          return topic === payload.topic;
        });
      });
      return _objectSpread(_objectSpread({}, state), {}, {
        favorites: map
      });

    case _actions.SET_SCROLL_STATE:
      return _objectSpread(_objectSpread({}, state), {}, {
        scrollTop: payload.scrollTop,
        scrollUrl: payload.scrollUrl
      });

    case _actions.SKIP_PROMO:
      return _objectSpread(_objectSpread({}, state), {}, {
        promoSkipped: true
      });

    case _actions.SET_MEDIA_STATE:
      return _objectSpread(_objectSpread({}, state), {}, {
        media: _objectSpread(_objectSpread({}, state.media), payload)
      });

    case _actions.SET_RATINGS:
      map = state.ratings;
      if (!map.hasIn([payload.year, payload.model])) map = map.setIn([payload.year, payload.model], (0, _immutable.List)());
      map = map.updateIn([payload.year, payload.model], function (list) {
        list = list // if topic is already rated, remove rating value and add it again to preserve topic count
        .filterNot(function (topic) {
          return topic.get(0) === payload.topic;
        });
        if (MAX_RATINGS_QUEUE && list.size >= MAX_RATINGS_QUEUE) list = list.shift();
        return list.push((0, _immutable.List)([payload.topic, payload.rating]));
      });
      return _objectSpread(_objectSpread({}, state), {}, {
        ratings: map
      });

    case _actions.NETWORK_ONLINE:
      return _objectSpread(_objectSpread({}, state), {}, {
        networkOnline: true
      });

    case _actions.NETWORK_OFFLINE:
      return _objectSpread(_objectSpread({}, state), {}, {
        networkOnline: false
      });

    case _reduxPersist.REHYDRATE:
      if (payload && payload.user) {
        return _objectSpread(_objectSpread(_objectSpread(_objectSpread({}, state), payload.user), rehydrateState), {}, {
          ratings: (0, _immutable.fromJS)(payload.user.ratings || {}),
          favorites: (0, _immutable.fromJS)(payload.user.favorites || {}),
          recent: (0, _immutable.fromJS)(payload.user.recent || {})
        });
      }

      return state;

    default:
      return state;
  }
}

var _default = user;
exports["default"] = _default;